import React, { Component } from 'react';
import styles from './Explore.module.css';
import {connect} from 'react-redux';
import Suggestions from '../Suggestions/Suggestions';
import Posts from '../Explore-Posts/Posts';

class Explore extends Component {

    state ={
        page: 'posts'
    }

    componentDidMount() {
        if(!this.props.loginStatus.isLoggedIn) {
            this.props.history.replace({pathname: '/'});
        }
    }

    componentDidUpdate() {
        if(!this.props.loginStatus.isLoggedIn) {
            this.props.history.replace({pathname: '/'});
        }
        
    }

    checkboxValueOnChangeHandler = (event) => {
        this.setState({page: event.target.value}); 
    }

    render() {
        return (
            <div className={styles.main}>
                <section>
                    <div className={styles.top}>
                      <h4>Explore</h4>
                        <div className={styles.explore}>
                            <div className={styles.header}>
                                <label>
                                    <input type="radio" name="genre" value="posts" 
                                    checked={this.state.page==='posts'} onChange={this.checkboxValueOnChangeHandler}/>
                                    <span>Discover Posts</span>
                                    <span className={styles.border}></span>
                                </label>
                                <label>
                                    <input type="radio" name="genre" value="suggestions" 
                                    checked={this.state.page==='suggestions'} onChange={this.checkboxValueOnChangeHandler}/>
                                    <span>Discover People</span>
                                    <span className={styles.border}></span>
                                </label>
                            </div>
                            <div className={styles.body}>
                               {this.state.page === 'posts' ?
                               <Posts /> : <Suggestions search={true}/>
                               }
                           </div>
                       </div>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        loginStatus: state.loginStatus,
        userData: state.userData
    }
}

export default connect(mapStateToProps)(Explore);